export const cascaLibrarySlug = 'bibliothèque-casca'
export const cascaLibraryPathname = '/groups/biblioth%C3%A8que-casca'
